import { GetCfjsonResponse } from '@metservicedev/platforms-services-interface/src/services/movIntegrationMDS/MovIntegrationMDSModel';

import { IStage } from '../index';

export interface WeatherWidgetRenderProps<SettingsType> {
    stage: IStage;
    settings: SettingsType;
    isRenderingForPDF?: boolean;
    isRenderingForForecast?: boolean;
    cfjsons?: GetCfjsonResponse[];
    metjwt?: string;
    theme?: string;
    isLoading?: boolean;
    datasets?: any[];
    setSettings?: (settings: SettingsType) => void;
    timezone?: string;
    updateInterval?: number;
    userTracking?: (properties?: any) => void; // When defined, the platmap will send user tracking events. The event should be defined at a higher level, only pass properties
}

export interface WeatherWidgetConfiguratorProps<SettingsType> {
    settings: SettingsType;
    setSettings: React.Dispatch<React.SetStateAction<SettingsType>>;
}

type weatherWidgetType =
    | 'platMap'
    | 'intervalChart'
    | 'runwayConditions'
    | 'runwayWindSpeed'
    | 'runwayRainGauge'
    | 'windBars'
    | 'windDirection'
    | 'weatherStation'
    | 'airportDial'
    | 'threatMatrix';

export interface WeatherWidget<SettingsType> {
    type: weatherWidgetType;
    Render: React.FC<WeatherWidgetRenderProps<SettingsType>>;
    defaultSettings: SettingsType;
}

export interface WeatherWidgetConfigurator<SettingType> {
    type: weatherWidgetType;
    Configurator: React.FC<WeatherWidgetConfiguratorProps<SettingType>>;
}

export interface IWidgetBlockSettings {
    fontSize: number;
    offsetLeft?: number;
    useFixedOffset?: boolean;
    canDownload?: boolean;
}

export const SpaceGeometryTypePoint = 'Point';
export interface ISpacePoint {
    type: typeof SpaceGeometryTypePoint;
    coordinates: [number, number]; // [lon, lat] rfc7946 GeoJson standard
}

export type ISpace = ISpacePoint;

export interface IDatability {
    id: string;

    // Required for data
    capabilityId?: string;
    // Required for data
    datasetId?: string; // stationId should be put here
    // Required for data
    timeRange?: string; // ISO-8601
    // Required for data
    space?: ISpace;
    // Required for data
    data_structure?: string;

    // Optional, used for regrid interpolation requests, legacy imo
    interpolationInterval?: string; // example PT1H

    // Optional, used for context to get datasets from backend, legacy imo
    _radius?: number;
}
